import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { formatCurrency } from '../../utils/expenseUtils';
import { CATEGORY_COLORS } from '../../utils/expenseAnalytics';

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const { label, amount, percentage } = payload[0].payload;
  return (
    <div className="bg-white rounded-xl px-3 py-2 shadow-warm-md border border-surface-200 text-sm">
      <p className="font-semibold text-ink-800">{label}</p>
      <p className="text-ink-500">{formatCurrency(amount)} ({percentage}%)</p>
    </div>
  );
};

const CategoryBreakdown = ({ data }) => {
  if (!data?.length) return null;

  return (
    <div className="card p-6">
      <h3 className="font-bold text-ink-900 text-[0.9375rem] mb-5">Spending by Category</h3>

      <div className="flex flex-col lg:flex-row items-center gap-6">
        {/* Donut chart */}
        <div className="w-full lg:w-1/2 flex justify-center">
          <ResponsiveContainer width="100%" height={240}>
            <PieChart>
              <Pie
                data={data}
                dataKey="amount"
                nameKey="label"
                cx="50%"
                cy="50%"
                innerRadius={55}
                outerRadius={95}
                paddingAngle={2}
                animationBegin={0}
                animationDuration={800}
              >
                {data.map((entry) => (
                  <Cell
                    key={entry.category}
                    fill={CATEGORY_COLORS[entry.category] || '#78716c'}
                    stroke="white"
                    strokeWidth={2}
                  />
                ))}
              </Pie>
              <Tooltip content={<CustomTooltip />} />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Legend table */}
        <div className="w-full lg:w-1/2 space-y-2">
          {data.map((entry) => (
            <div key={entry.category} className="flex items-center gap-3">
              <div
                className="w-3 h-3 rounded-full flex-shrink-0"
                style={{ backgroundColor: CATEGORY_COLORS[entry.category] || '#78716c' }}
              />
              <span className="text-sm text-ink-600 flex-1 truncate">
                {entry.icon} {entry.label}
              </span>
              <span className="text-sm font-semibold text-ink-800 tabular-nums">
                {formatCurrency(entry.amount)}
              </span>
              <span className="text-xs text-ink-400 w-10 text-right tabular-nums">
                {entry.percentage}%
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CategoryBreakdown;
